'use client';

import { Fragment } from 'react';

import { useModalController } from '@uikit/components/Modal';
import Settings from '@uikit/icons/Settings';

import { useSwapExperienceStore } from '../utilities/SwapExperienceStore';
import SlippageModal from './SlippageModal';

const SwapSlippageControl = () => {
  const store = useSwapExperienceStore();

  const modal = useModalController();

  return (
    <Fragment>
      <SlippageModal modalController={modal} maxSlippagePercent={50} />

      <button
        className="button button-ghost gap-1 p-0 border-0 items-center font-normal min-h-0 inline-flex"
        onClick={modal.open}
      >
        <span className="leading-none">{store.slippagePercent}%</span>
        <Settings className="icon-xs text-secondary" />
      </button>
    </Fragment>
  );
};

export { SwapSlippageControl };
